import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setAuthCookie, setSessionCookie, redirectToErp } from 'constants/auth';

function AuthCallback() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    const session = params.get('session');

    if (!token) {
      redirectToErp();
      return;
    }

    if (session) {
      setSessionCookie(session);
    }
    setAuthCookie(token);
    window.location.href = '/docs/';
  }, [location]);

  return null;
}

export default AuthCallback;
